import { render, staticRenderFns } from "./write.vue?vue&type=template&id=b3a6bb3a"
import script from "./write.vue?vue&type=script&lang=js"
export * from "./write.vue?vue&type=script&lang=js"
import style0 from "./write.vue?vue&type=style&index=0&id=b3a6bb3a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports